import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Link from '@mui/material/Link';

const styles = theme => ({
  root: {
    width: 'auto',
    height: 'auto',
    marginTop: theme.spacing(4),
    display: 'block',
    textAlign: 'center',
  },
  reference: {
    minWidth: 0,
    padding: 0,
    marginLeft: theme.spacing(2),
    '& a': {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: 14,
    },
  },
  copyRight: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: theme.spacing(2),
    fontSize: 14,
  },
  callAction: {
    display: 'block',
    margin: 'auto',
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.down('xl')]: {
      marginBottom: theme.spacing(5),
    },
    maxWidth: 'max-content',
    minWidth: 'fit-content',
    padding: 0,
    '& p': {
      margin: 0,
      cursor: 'default',
    },
  },
});

const links = [
  { title: 'About', href: 'https://www.rakuna.co/about/' },
  { title: 'Blog', href: 'https://www.rakuna.co/blog/' },
  { title: 'Privacy Policy', href: 'https://www.rakuna.co/legal/privacy_policy.pdf' },
  { title: 'Terms of Service', href: 'https://secure.rakuna.co/legal/Rakuna_Members_TOS.pdf' },
];

const FooterMobile = ({ classes }) => (
  <React.Fragment>
    <BottomNavigation className={classes.root}>
      {links.map(link => (
        <BottomNavigationAction
          showLabel
          component={Link}
          href={link.href}
          target="_blank"
          label={link.title}
          className={classes.reference}
          key={link.title}
        />
      ))}
      <BottomNavigationAction
        showLabel
        label={`© Copyright ${new Date().getFullYear()} Rakuna.co. All rights reserved.`}
        className={classes.callAction}
      />
    </BottomNavigation>
  </React.Fragment>
);

FooterMobile.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(FooterMobile);
